<template>
    <div ref="root">
        <app-modulebackground
            :module-id="module.id"
            custom-class="contactwidget__background module__background"
        >
        </app-modulebackground>
        <div
            class="contactform__container module__container"
            v-bind:class="{ container__boxed: [1, 2, 3, 4, 5, 6].includes(module.layout.type) }"
        >
            <div class="contactform__inner module__inner">
                <div class="contactform__inner--main module__inner--main">
                    <div
                        class="contactform__inner-row module__inner-row"
                        v-if="module.data.title || module.data.subtitle"
                    >
                        <div class="contactform__inner-col module__inner-col">
                            <div class="contactform__header module__header">
                                <h2
                                    class="contactform__title module__title font-h2 color-h2"
                                    v-if="module.data.title"
                                    v-html="module.data.title"
                                ></h2>
                                <h3
                                    class="contactform__subtitle module__subtitle font-h3 color-h3"
                                    v-if="module.data.subtitle"
                                    v-html="module.data.subtitle"
                                ></h3>
                            </div>
                        </div>
                    </div>
                    <div class="contactform__inner-row module__inner-row">
                        <div class="contactform__inner-col module__inner-col">
                            <div class="contactform__content-block module__content-block">
                                <div
                                    class="contactform__content-block--left module__content-block--left"
                                    v-bind:class="{
                                        'col__width--full': [1, 2, 3, 4, 5, 6].includes(
                                            module.layout.type
                                        )
                                    }"
                                    v-if="module.data.text"
                                >
                                    <div class="contactform__inner-row module__inner-row">
                                        <div class="contactform__inner-col module__inner-col">
                                            <div
                                                class="contactform__text module__text font-p color-p module__cms"
                                                v-if="module.data.text"
                                                v-html="module.data.text"
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="contactform__content-block--right module__content-block--right"
                                    v-bind:class="{
                                        'col__width--full': [1, 2, 3, 4, 5, 6].includes(
                                            module.layout.type
                                        )
                                    }"
                                >
                                    <div class="contactform__inner-row module__inner-row">
                                        <div class="contactform__inner-col module__inner-col">
                                            <div class="contactform__form-wrap">
                                                <app-form :module-id="module.id"></app-form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Form from '@/components/assorted/Form';
import ModuleBackground from '@/components/assorted/ModuleBackground';

export default {
    data() {
        return {};
    },
    components: {
        'app-form': Form,
        'app-modulebackground': ModuleBackground
    },
    methods: {},
    computed: {},
    mounted() {},
    props: {
        module: Object
    }
};
</script>
